"use client";
import React from "react";
import { Link } from "react-router-dom";
// import Link from "next/link";
import { useTranslation,Trans  } from 'react-i18next';
const Redevelopment = () => {
    const { t } = useTranslation();
    return (
        <section className="lyt-section typ-pb-0" id="directors">
            <div className="container">
                <div className="heading-wrapper typ-mb-60">
                    <div>
                        <h2
                            className="bs-heading typdblue mb-2"
                            data-aos="fade-in"
                            data-aos-delay="200"
                        >
                           {t('ourDirectors')}
                        </h2>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="typ-directors-flex typ-mb0">
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">Aarti Harbhajanka</h4>
                                <p className="designation">Real Estate Research</p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">⁠Domnic Romell</h4>
                                <p className="designation">
                                President, CREDAI - MCHI
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                       
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">Manoj Daisaria</h4>
                                <p className="designation">
                                Past President, PEATA
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">⁠Rajan Bandelkar</h4>
                                <p className="designation">
                                Vice Chairman, NAREDCO West
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">⁠Ranjit Naiknavare</h4>
                                <p className="designation">
                                President, CREDAI - Pune Metro
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">⁠Vinay Thyagaraj</h4>
                                <p className="designation">
                                Chartered Accountant
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">⁠Harshad Bhadbhade</h4>
                                <p className="designation">
                                President, Bar Association of MahaRERA and MahaREAT
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">Vasant Prabhu</h4>
                                <p className="designation">
                                Past Secretary, MahaRERA
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="bs-card typ-founder-card typ-small-card">
                            <div className="card">
                                <h4 className="card-head">Anand Gupta </h4>
                                <p className="designation">
                                Vice President, Builders Association of India
                                </p>
                                <div className="icons-flex typ-mt-12">
                                    <Link href="#">
                                        <span className="icon icon-linkedin"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-twitter"></span>
                                    </Link>
                                    <Link href="#">
                                        <span className="icon icon-mail"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="typ-center-lyt">
                        <Link
                            className="bs-btn"
                            href="#"
                            aria-label="Navigate to Contact Us page"
                            data-aos="fade-in"
                            data-aos-delay="200"
                        >
                            View All{" "}
                        </Link>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Redevelopment;
